import './MediaRecorderError.scss'
import React from 'react'
import { ReactComponent as CheckSVG } from './images/check.svg'
import { ReactComponent as WatchSVG } from './images/watch.svg'
import { isMobile as isMobileF } from '../../utils/utils'
import { Translated } from '../../utils/translated'

const MediaRecorderError = (props) => {

    const isMobile = isMobileF();

    return props.isShow ? (
        <div className='media-recorder-error'>
            <div className='title'>
                <Translated id='app.mediarecorder.title' />
            </div>

            <div className='content'>
                {!isMobile && <div className='video-help'>
                    <iframe title='video-help' width='100%' height='100%'
                        src="https://www.youtube.com/embed/sBxl1zm-qFc" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                    </iframe>
                </div>}

                {!isMobile
                    ? <div className='help-steps-desktop'>
                        <div>
                            <p style={{ marginTop: 0 }}>
                                <Translated id='app.mediarecorder.mac-step-1' />
                            </p>
                            <div className='remark'>
                                <p>
                                    <Translated id='app.mediarecorder.mac-step-1-hint-1' />
                                </p>
                                <div className='check'>
                                    <CheckSVG />
                                </div>
                                <p style={{ display: 'inline' }}>
                                    <Translated id='app.mediarecorder.mac-step-1-hint-2' />
                                </p>
                            </div>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.mac-step-2' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.mac-step-3' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p style={{ display: 'inline' }}>
                                <Translated id='app.mediarecorder.mac-step-4' />
                            </p>
                            <div className='button-box'>
                                <button className='btn-gradient' onClick={() => window.location.reload(false)}>
                                    &#10227;&nbsp;&nbsp;<Translated id='app.mediarecorder.mac-button' />
                                </button>
                            </div>
                        </div>
                    </div>
                    : <div className='help-steps-mobile'>
                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-1' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-2' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-3' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-4' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-5' />
                            </p>
                        </div>
                        <div className='hr'></div>

                        <div>
                            <p>
                                <Translated id='app.mediarecorder.iphone-step-6' />
                            </p>
                        </div>
                    </div>}
            </div>

            {isMobile && <div className='watch' onClick={() => window.location.href = 'https://youtu.be/Js4mtBslNCQ'}>
                <WatchSVG />
                <span><Translated id='app.mediarecorder.iphone-watch' /></span>
            </div>}
        </div>
    ) : null
}

export default MediaRecorderError
